
import {supportedLanguageList} from "./AppSettings";

// These are the supported languages.
const AllSupportedLanguageList = [
    "de",
    "de_de",
    "en",
    "en_us",
    "en_gb",
    "es",
    "es_419",
    "fi",
    "fi_fi",
    "fr",
    "fr_CA",
    "sv",
    "sv_se",
    "no",
    "no_NO",
    "da",
    "da_DK",
    "nl",
    "nl_NL",
    "it",
    "it_IT",
    "pt",
    "pt_PT"
];

const SupportedLanguagesMap = {
    // region-less keys
    en: "en_US",
    de: "de_DE",
    es: "es_419",
    fi: "fi_FI",
    fr: "fr_CA",
    no: "nb_NO",
    sv: "sv_SE",
    da: "da_DK",
    nl: "nl_NL",
    it: "it_IT",
    pt: "pt_PT",
    // region based keys
    en_US: "en_US",
    en_GB: "en_GB",
    de_DE: "de_DE",
    fi_FI: "fi_FI",
    sv_SE: "sv_SE",
    es_419: "es_419",
    fr_CA: "fr_CA",
    no_NO: "no_NO",
    da_DK: "da_DK",
    nl_NL: "nl_NL",
    it_IT: "it_IT",
    pt_PT: "pt_PT"
}

// Convert language codes from the '-' format that browsers use to the '_' format that we use.
const FormatLanguageCode = (language) => {
    if (language.indexOf("-") > 0) {
        return language.replace("-", "_");
    }

    return language;
};

// Chooses the best language that we support and returns the language code.
const ChooseBestSupportedLanguage = (acceptLanguageHeader) => {
    let languages = acceptLanguageHeader.split(",");

    let bestLanguage = undefined;
    let bestQ = 0;

    let supported_lang_list = supportedLanguageList();

    languages.forEach((language) => {
        let currentLanguage = "";
        let currentQ = 0;

        if (language.indexOf(";") >= 0) {
            // If there is a semicolon then there should be a q value indicating language priority.
            let languageValues = language.split(";");
            currentLanguage = FormatLanguageCode(languageValues[0].trim());

            if (languageValues[1][0] === 'q') {
                currentQ = parseFloat(languageValues[1].split("=")[1].trim())
            }
        } else {
            currentLanguage = FormatLanguageCode(language.trim());
            currentQ = 1.0;
        }

        if (supported_lang_list.includes(currentLanguage.toLowerCase()) && currentQ > bestQ) {
            bestQ = currentQ;
            bestLanguage = currentLanguage;
        }
    });

    return bestLanguage;
};

export { ChooseBestSupportedLanguage, AllSupportedLanguageList, SupportedLanguagesMap };